import { useEffect, useState } from "react";
import { Box, Center, Flex, Grid, GridItem, IconButton, Image, Select, Spinner, Text } from "@chakra-ui/react";
import CustomButton from "../../../../components/Inputs/Button/customButton";
import { CustomTable } from "../../../../components";
import { Column } from "../../../../components/CustomTable/customTable";
import MyDiv from "./CertificateCategory.style";
import Category from "./category";
import { CategoryItem } from "./model";
import { useFetch } from "../../../../hooks/useFetch";
import { CustomToast } from "../../../../components";
import { ChevronDownIcon, EditIcon } from "@chakra-ui/icons";
import PlusIcon from "../../../../assets/images/Vector.svg";

const AwardCertificateCategory = () => {
  const [categories, setCategories] = useState<CategoryItem[]>([]);
  const [isOpen, setIsOpen] = useState(false);
  const [editRow, setEditRow] = useState<CategoryItem | null>(null);

  const openAdd = () => {
    setEditRow(null);
    setIsOpen(true);
  };

  const { addToast } = CustomToast();
  const { fetchApi, loading } = useFetch(addToast);

  const fetchCategories = async () => {
    try {
      const res = await fetchApi("Hrlense_Awards/categories", "GET");

      if (res && Array.isArray(res)) {
        setCategories(res);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const handleSave = async (item: CategoryItem) => {
    const url = editRow
      ? `Hrlense_Awards/categories/${editRow.id}`
      : "Hrlense_Awards/categories";

    const method = editRow ? "PUT" : "POST";
    const response = await fetchApi(url, method, item, null);
    if (response) {
      addToast({ message: "Category created successfully", status: "success" });
    }
    fetchCategories();
  };
  const getStatusColor = (status: boolean) => (status ? "#38A169" : "#E53E3E");

  useEffect(() => {
    fetchCategories();
  }, [isOpen]);

  const handleEdit = (row: CategoryItem) => {
    setEditRow(row);
    setIsOpen(true);
  };

  const handleStatusChange = async (row: CategoryItem, value: string) => {
    const updatedCategory = {
      ...row,
      status: value === "true" ? true : false,
    };

    const res = await fetchApi(
      `Hrlense_Awards/categories/${row.id}`,
      "PUT",
      updatedCategory,
      null,
      "Status updated successfully",
    );

    if (res) {
      setCategories((prev) =>
        prev.map((cat) =>
          cat.id === row.id ? { ...cat, status: value === "true" } : cat,
        ),
      );
    }
  };

  return (
    <MyDiv>
      <Box>
        <Flex className="page_heading flex_header">
          <Text className="font-poppins text_semibold text_3xl">Award Category</Text>
          <Flex>
            <CustomButton title="Add New Award & Certificate" className="btn font-poppins text_sm text_medium" onClick={openAdd} rightIcon={<Image src={PlusIcon} />} />
          </Flex>
        </Flex>

        <Grid className='grid_container' mt={1}>
          <GridItem colSpan={12}>
            <Box position="relative" minH="300px">
              {loading ? (
                <Center position="absolute" top={0} left={0} right={0} bottom={0}>
                  <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="#006838" size="xl" />
                </Center>
              ) : (
                <>
                  <CustomTable value={categories}>
                    <Column header="S.No" body={(_, i) => i + 1} />
                    <Column header="Category" body={(r: CategoryItem) => r.name} />
                    <Column header="Description" body={(r: CategoryItem) => r.description}/>
                    <Column
                      header="Status"
                      body={(row: CategoryItem) => (
                        <Select
                          value={row.status ? "true" : "false"}
                          onChange={(e) => handleStatusChange(row, e.target.value)}
                          width="120px"
                          height="32px"
                          icon={<ChevronDownIcon />}
                          borderRadius="4px"
                          color={getStatusColor(row.status)}
                          className="font-poppins text_medium text_xsm"
                        >
                          <option value="true" style={{ color: "#38A169" }}>
                            Active
                          </option>
                          <option value="false" style={{ color: "#E53E3E" }}>
                            Inactive
                          </option>
                        </Select>
                      )}
                    />

                    <Column
                      header="Action"
                      body={(row: CategoryItem) => (
                        <Flex gap={2}>
                          <IconButton
                            aria-label="Edit category"
                            icon={<EditIcon />}
                            size="sm"
                            variant="ghost"
                            colorScheme="blue"
                            onClick={() => handleEdit(row)}
                          />
                        </Flex>
                      )}
                    />
                  </CustomTable>

                </>)}
            </Box>

          </GridItem>
        </Grid>
        <Category
          isOpen={isOpen}
          onClose={() => {
            setIsOpen(false);
            setEditRow(null);
          }}
          onSave={handleSave}
          editData={editRow}
        />
      </Box>
    </MyDiv>
  );
};

export default AwardCertificateCategory;
